import React from "react";
import { ModeRendererProps } from "./types";

export function TinguelyWheelsMode({ brand }: ModeRendererProps) {
  return (
    <g>
      {/* Background pattern */}
      {Array.from({ length: 20 }).map((_, i) => (
        <circle
          key={i}
          cx={100 + (i % 5) * 150}
          cy={150 + Math.floor(i / 5) * 250}
          r="3"
          fill={brand.white}
          opacity="0.2"
        />
      ))}
      
      {/* Large central wheel */}
      <g transform="translate(397 540)">
        <use href="#wheel" transform="scale(4)" />
        <circle r="180" fill="none" stroke={brand.aqua} strokeWidth="2" opacity="0.6" />
        <circle r="200" fill="none" stroke={brand.violet} strokeWidth="1" strokeDasharray="10 5" opacity="0.4" />
        
        {/* Rotating smaller wheels */}
        {Array.from({ length: 6 }).map((_, i) => {
          const angle = (i * Math.PI * 2) / 6;
          const radius = 220;
          const x = radius * Math.cos(angle);
          const y = radius * Math.sin(angle);
          return (
            <g key={i} transform={`translate(${x} ${y}) rotate(${i * 60})`}>
              <use href="#wheel" transform="scale(0.8)" />
              <line x1="0" y1="0" x2="0" y2="-220" stroke={brand.amber} strokeWidth="2" opacity="0.5" />
            </g>
          );
        })}
      </g>
      
      {/* Corner wheels */}
      {[
        [120, 150],
        [674, 150],
        [120, 973],
        [674, 973],
      ].map(([x, y], i) => (
        <g key={i} transform={`translate(${x} ${y}) rotate(${i * 90})`}>
          <use href="#wheel" transform="scale(1.2)" />
        </g>
      ))}
    </g>
  );
}
